import React from 'react';
import styled from 'styled-components';
import { FormCheckbox } from '@catalogo/theme-form-builder/src/components/checkbox';
import TheftIconIcon from '@catalogo/ui-americanas-desktop-svg/icon-theft-protection.svg';
import { CheckBoxContainerProps, TheftProtectionComponent } from './interfaces';

export const TheftProtection: TheftProtectionComponent = props => {
  const {
    coverageTime,
    numberOfInstallments,
    price,
    isTheftSelected,
    showRobberyAndTheftInsurance,
    toggleTheftSelected,
    showCoverage,
    showHiringPolicy,
  } = props;
  if (!coverageTime || !numberOfInstallments || !price) {
    return null;
  }

  return (
    <div>
      <Title>eeei, aproveite também</Title>
      <Box isCheckboxSelected={isTheftSelected}>
        <CheckboxContainer isSelected={isTheftSelected}>
          <FormCheckbox checked={isTheftSelected} onClick={toggleTheftSelected} />
        </CheckboxContainer>
        <TheftIcon />
        <Text>
          {coverageTime} de <span>seguro roubo e furto qualificado + quebra acidental</span> por {numberOfInstallments}x
          de <strong>{price}</strong>
          &nbsp;s/ juros.
          <BoxAnchor onClick={showCoverage}>ver cobertura</BoxAnchor>
        </Text>
      </Box>
      {isTheftSelected && (
        <Disclaimer>
          ao clicar em comprar você aceita os termos e condições:{' '}
          <DisclaimerAnchor onClick={showRobberyAndTheftInsurance}>seguro roubo e furto qualificado</DisclaimerAnchor>
          &nbsp;e&nbsp;
          <DisclaimerAnchor onClick={showHiringPolicy}>política de contratação.</DisclaimerAnchor>
        </Disclaimer>
      )}
    </div>
  );
};

const TheftIcon = styled(TheftIconIcon)`
  margin-right: 14px;
`;

const Title = styled.strong`
  display: block;
  font-size: 16px;
  line-height: 19px;
  margin-bottom: 16px;
`;

const Box = styled.div`
  display: flex;
  align-items: center;
  padding: 16px;
  box-shadow: 0px 1px 8px rgba(0, 0, 0, 0.08);
  border-radius: 12px;
  margin-bottom: ${({ isCheckboxSelected }: { isCheckboxSelected: boolean }) => (isCheckboxSelected ? '8px' : '24px')};
`;

const CheckboxContainer = styled.div<CheckBoxContainerProps>`
  & > div {
    border-radius: 6px;
    border: 2px solid ${({ theme, isSelected }) => (isSelected ? theme.primaryColor : theme.grey.medium)};
    width: 20px;
    height: 20px;
    padding: 3px;
    margin-right: 14px;
  }
`;

const Text = styled.p`
  font-size: 14px;
  line-height: 16px;
  color: ${({ theme }) => theme.grey.dark};
  max-width: 210px;

  > span {
    font-weight: 700;
  }

  > strong {
    color: ${({ theme }) => theme.grey.darker};
  }
`;

const BoxAnchor = styled.a`
  display: block;
  color: ${({ theme }) => theme.grey.dark};
  text-decoration: underline;
  line-height: 16px;
  margin-top: 2px;
  cursor: pointer;
`;

const Disclaimer = styled.p`
  font-family: Arial, Helvetica, sans-serif;
  font-size: 12px;
  line-height: 14px;
  color: #6f6f6f;
  margin-bottom: 24px;
`;

const DisclaimerAnchor = styled.a`
  text-decoration: underline;
  line-height: 16px;
  margin-top: 2px;
  cursor: pointer;
`;

export default TheftProtection;
